import { FORMAT_DATE, FORMAT_TIME } from 'common/constant';
import { ResponseGenerator } from 'common/type';
import i18n from 'i18n/i18n';
import moment from 'moment';
import { all, put, takeLatest } from 'redux-saga/effects';
import { deleteKeyEmpty } from 'utils';

import { getEdiIdList, getEdiLogDetailAPI, getEdiLogListAPI } from './api';
import {
  handleGetEdiLogDetailRequest,
  handleGetEdiLogDetailResponse,
  handleGetListEdiIdRequest,
  handleGetListEdiIdResponse,
  handleGetListEdiLogRequest,
  handleGetListEdiLogResponse,
} from './slice';

function* handleGetListEdi(action: any) {
  const params = action.payload;

  const convertParams = deleteKeyEmpty({
    ...params,
    ERROR_ONLY: !params.ERROR_ONLY || params.ERROR_ONLY === 'false' ? '' : '1',
    S_DT: params?.S_DT ? moment(params?.S_DT).format(FORMAT_DATE) : null,
    E_DT: params?.E_DT ? moment(params?.E_DT).format(FORMAT_DATE) : null,
    SDT_TIME_FROM: params?.SDT_TIME_FROM ? moment(params?.SDT_TIME_FROM).format(FORMAT_TIME) : null,
    SDT_TIME_TO: params?.SDT_TIME_TO ? moment(params?.SDT_TIME_TO).format(FORMAT_TIME) : null,
  });

  try {
    const response: ResponseGenerator = yield getEdiLogListAPI(convertParams);
    yield put(
      handleGetListEdiLogResponse({
        data: response.data,
        ediListMessage: response?.data.records.length > 0 ? '' : i18n?.t('message.common.0001'),
      })
    );
  } catch (error) {
    yield put(
      handleGetListEdiLogResponse({
        ediListMessage: '',
      })
    );
  }
}

function* handleGetEdiLogDetail(action: any) {
  const { params } = action.payload;
  try {
    const response: ResponseGenerator = yield getEdiLogDetailAPI(params);
    if (response?.meta?.code === 0) {
      yield put(handleGetEdiLogDetailResponse({ ...response.data, statusErr: false }));
    } else {
      yield put(handleGetEdiLogDetailResponse({ ...response.data, statusErr: false }));
    }
  } catch (error) {
    yield put(handleGetEdiLogDetailResponse({ statusErr: true }));
  }
}

function* handleGetEdiIdList(action: any) {
  try {
    const response: ResponseGenerator = yield getEdiIdList();
    if (response?.meta?.code === 0) {
      yield put(handleGetListEdiIdResponse(response.data));
    } else {
      yield put(handleGetListEdiIdResponse(response.data));
    }
  } catch (error) {
    yield put(handleGetListEdiIdResponse({}));
  }
}

function* watchEdiSaga() {
  yield all([
    takeLatest(handleGetListEdiLogRequest, handleGetListEdi),
    takeLatest(handleGetEdiLogDetailRequest, handleGetEdiLogDetail),
    takeLatest(handleGetListEdiIdRequest, handleGetEdiIdList),
  ]);
}

export default watchEdiSaga;
